import React from 'react';
import cn from 'classnames';

import {useContentCardContext} from '../../ContentCard';

import {IContentCardTitleProps} from './IContentCardTitle';

import styles from './ContentCardTitle.module.scss';

const ContentCardTitle = (props: IContentCardTitleProps) => {
	const {style} = useContentCardContext();

	return (
		<h3
			className={cn(
				styles['content-card__title'],
				{
					[styles[`content-card__title--${style}`]]: style,
				},
				'content-card__title'
			)}
		>
			{props.children}
		</h3>
	);
};

export default ContentCardTitle;
